module.exports = __webpack_public_path__ + "img/priscilla-logo-letter-w.895ef3fd.svg";